//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex';
import TextLink from 'components/blocks/TextLink.vue'


export default {
  block: 'flexButtons',
  props: ['data'],
  data() {
    return {
      showColumn1: ((this.data.header1 || this.data.text1 || this.data.img1) || ((this.data.columns == 1) || (this.data.columns == 2) || (this.data.columns == 3))),
      activeColumn: (this.startColumn) ? this.startColumn : 1,
      shrinkColumn1: !(this.data.header3 || this.data.text3 || this.data.img3),
      showColumn2: ((this.data.header2 || this.data.text2 || this.data.img2) || ((this.data.columns == 3) || (this.data.columns == 2))),
      shrinkColumn3: !(this.data.header1 || this.data.text1 || this.data.img1),
      showColumn3: (this.data.header3 || this.data.text3 || this.data.img3 || this.data.columns == 3),
    }
  },
  components: {
    TextLink,
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
  },
  methods: {
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      // Add singleColumn blockModifier if specified
      if (this.data.mobile != null)
        bms += (this.data.mobile.singleColumn) ? ' bm-singleMobileColumn' : '';

      return bms;
    },
  },
}



// WEBPACK FOOTER //
// ./components/globalBlocks/FlexButtons.vue